// extracted by mini-css-extract-plugin
export default {"copyable":"copyable-duelH0","input":"input-xZfiC4"};